import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import User from "@/app/models/User";
import Client from "@/app/Http/Client";
import FunctionGroup from "@/app/models/FunctionGroup";

@Module({namespaced: true})
export default class AuthModule extends VuexModule {
    private me: User | null = null;
    private functionGroup: FunctionGroup | null = null;

    get current(): User | null {
        return this.me;
    }

    get currentFunctionGroup(): FunctionGroup | null {
        return this.functionGroup;
    }

    get hasFunctionGroup(): boolean {
        return this.functionGroup !== null;
    }

    get isLoggedIn(): boolean {
        return this.me !== null
               && this.functionGroup !== null;
    }

    @Mutation
    postLogin(me: User) {
        this.me = me;
    }

    @Mutation
    postLogout() {
        this.me = null;
    }

    @Mutation
    setFunctionGroup(functionGroup: FunctionGroup|null) {
        this.functionGroup = functionGroup;
    }

    @Action
    public async login(data: { email: string, password: string }) {
        await Client.post('/login', data);

        const me = await User.me();

        this.context.commit('postLogin', me);
    }

    @Action
    public async employeeLogin(employeeId: number) {
        await Client.post('/login', {employee: employeeId})

        const me = await User.me();

        this.context.commit('postLogin', me);
    }

    @Action
    public async refreshMe() {
        const me = await User.me();

        this.context.commit('postLogin', me);
    }

    @Action
    public async resetPassword(data: { token: string, email: string, password: string, password_confirmation: string }) {
        await Client.post('/password/reset', data);

        const me = await User.me();

        this.context.commit('postLogin', me);
    }

    @Action
    public async logout() {
        await Client.post('/logout');

        this.context.commit('postLogin', null);
    }
}